/*
 *
 * IndexChannels
 * */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isString, isObject } from 'utils/helpers';
import {
  selectChannelFormLogo,
  selectChannelFormBackground,
  selectChannelFormGalleryBackground,
  selectChannelThemes,
  selectChannelFormThemeId,
  selectChannelThemeInstances,
  selectChannelFormThemeInstance,
  selectBrandFormData,
  selectMessageFormData,
} from './selectors';
import {
  patchChannelRequest,
  fetchChannelDetailRequest,
  fetchUpdatedChannelDetailRequest,
} from './actions';

import Forms from './Forms';
import {
  selectIsPhotographer,
} from 'containers/App/selectors';

import moment from 'moment';
import Loader from 'components/Loader';
import { colors } from 'globalStyles';

const urlFix = (url) => url && url.slice(-11) !== 'missing.png' ? url : null;
const makeUrl = (file) => window.URL.createObjectURL(file);

class EditChannel extends Component {
  componentWillMount() {
    const { channelDetail, fetchDetail, match: { params: { channelId } } } = this.props;
    if (!channelDetail || channelId) {
      fetchDetail(channelId);
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isSaving && !this.props.isSaving) {
      const { fetchUpdatedDetail, match: { params: { channelId } } } = this.props;
      fetchUpdatedDetail(channelId);
    }
  }

  render() {
    const {
      isFetching,
      channelDetail,
      match: { params: { channelId } },
      channelFormLogo,
      channelFormBackground,
      galleryColor,
      channelThemes,
      channelThemeInstances,
      isPhotographer,
      patchChannel,
      themeId,
      themeInstanceId,
      brandForm,
      messageForm,
      isSaving
    } = this.props;

    if (!channelDetail) return <div />;
    let channel = { ...channelDetail };
    const instanceId = channel && channel.channel_theme_instance;
    const channelThemeInstance = channelThemeInstances[instanceId];

    if (channel && isPhotographer && channelThemeInstance) {

      channel = {
        ...channel,
        ...channelThemeInstance
      };
    }

    const logoImage = isObject(channelFormLogo)
      ? makeUrl(channelFormLogo[0])
      : channel && urlFix(channel.big_logo_image_url);
    const overlayImage = isObject(channelFormBackground)
      ? makeUrl(channelFormBackground[0])
      : channel && urlFix(channel.overlay_image_url);
    const backgroundColor = isString(channelFormBackground)
      ? channelFormBackground
      : channel && channel.app_background_color;

    const bgColorChanged =
      isString(channelFormBackground)
      && !isObject(channelFormBackground);
    const overlayChanged =
      isObject(channelFormBackground)
      && !isString(channelFormBackground);

    const previewProps = {
      logoImage,
      overlayImage,
      backgroundColor,
      bgColorChanged,
      overlayChanged,
      galleryColor,
      brandForm,
      messageForm,
    };

    const initialChannel = Object.assign(
      {},
      {
        with_photo_filter:
          channel && channel.channel_theme_instance.with_photo_filter
            ? channel.channel_theme_instance.with_photo_filter
            : false,
        with_photo_filter_graphic: true,
        email_required:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "email").required,
        email_enabled:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "email").enabled,
        phone_required:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "phone").required,
        phone_enabled:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "phone").enabled,
        twitter_required:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "twitter").required,
        twitter_enabled:
          channel &&
          channel.share_types &&
          channel.share_types.find((cst) => cst.name === "twitter").enabled,
        channel_theme_id:
          channel && channel.channel_theme_instance
            ? channel.channel_theme_instance.channel_theme_id
            : null,
        first_line_text:
          channel && channel.channel_theme_instance
            ? channel.channel_theme_instance.first_line_text
            : null,
        second_line_text:
          channel && channel.channel_theme_instance
            ? channel.channel_theme_instance.second_line_text
            : null,
      },
      { ...channel, client: channel.client ? channel.client.name : "" }
    );
    return (
      <div>
        {isFetching || isSaving && <Loader color={colors.MAIN_COLOR} size="large" isOverlay={true} />}
        <Forms
          title="Edit Channel"
          onSubmit={patchChannel}
          initialValues={initialChannel}
          channelThemes={channelThemes}
          themeId={themeId}
          edit={true}
          disabled={
            channel.event_date <= moment(new Date()).format("YYYY-MM-DD") &&
            isPhotographer
              ? true
              : false
          }
          themeInstanceId={themeInstanceId}
          channelThemeInstances={channelThemeInstances}
          {...previewProps}
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  channelDetail: state => state.channels.channelDetail,
  isFetching: state => state.channels.isFetching,
  channelFormLogo: selectChannelFormLogo(),
  channelFormBackground: selectChannelFormBackground(),
  galleryColor: selectChannelFormGalleryBackground(),
  channelThemes: selectChannelThemes(),
  isPhotographer: selectIsPhotographer(),
  themeId: selectChannelFormThemeId(),
  channelThemeInstances: selectChannelThemeInstances(),
  themeInstanceId: selectChannelFormThemeInstance(),
  brandForm: selectBrandFormData(),
  messageForm: selectMessageFormData(),
  isSaving: state => state.channels.isSaving,
});

const mapDispatchToProps = (dispatch, { match: { params } }) => ({
  fetchUpdatedDetail: (id) => dispatch(fetchUpdatedChannelDetailRequest(id)),
  fetchDetail: (id) => dispatch(fetchChannelDetailRequest(id)),
  patchChannel: (data) =>
    dispatch(patchChannelRequest({ id: params.channelId, data })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditChannel);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/EditChannel.js